import MainProject from '@/model/MainProject'
import DataUtils from '@/model/DataUtils'
import { getMallNewBinHandle, getWritableDataBinHandle } from '@/features/project-disk/fs'
import { writeMallNewBin } from '@/features/project-mall/runtime'

const PROJECT_CACHE_DIR = 'cache'

/** 删除 Data/cache 下所有 .bin 分片。 */
async function clearProjectCache(dataDirHandle: FileSystemDirectoryHandle): Promise<void> {
  try {
    const cacheDir = await dataDirHandle.getDirectoryHandle(PROJECT_CACHE_DIR, { create: false })
    for await (const [name, entry] of cacheDir.entries()) {
      if (entry.kind === 'file' && name.endsWith('.bin')) {
        try {
          await cacheDir.removeEntry(name)
        } catch {
          /* ignore */
        }
      }
    }
  } catch {
    /* 无 cache 目录 */
  }
}

/**
 * 写入完整 Data/projects.bin，并清空 Data/cache（与文档“发布/导出时合并”一致）。
 */
export async function mergeFullProjectToDiskAndClearCache(
  rootHandle: FileSystemDirectoryHandle,
  project: MainProject,
): Promise<void> {
  const dataDir = await rootHandle.getDirectoryHandle('Data', { create: true })
  const binHandle = await getWritableDataBinHandle(dataDir)

  const ver = project.projectConstant.dataVersion
  DataUtils.dataVersion = ver
  project.dataVer = ver

  const bytes = project.writeBinBuffer()

  const writable = await binHandle.createWritable()
  const copy = new Uint8Array(bytes.byteLength)
  copy.set(bytes)
  await writable.write(copy)
  await writable.close()

  const mallNewHandle = await getMallNewBinHandle(dataDir, true)
  const mallNewWritable = await mallNewHandle.createWritable()
  const mallNewBytes = writeMallNewBin(project)
  const mallNewCopy = new Uint8Array(mallNewBytes.byteLength)
  mallNewCopy.set(mallNewBytes)
  await mallNewWritable.write(mallNewCopy)
  await mallNewWritable.close()

  await clearProjectCache(dataDir)
}
